import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Header, SidePanel, FooterPanel } from './components/index';
import { useWindowSize } from '../../utils/hooks';
import { layoutResponsive } from '../../utils/constants';
import AppNotification from '../common/AppNotification/AppNotification';
import classes from './Layout.module.scss';

export default function Layout({ children }) {
  const size = useWindowSize();
  const appNotification = useSelector((state) => state.appNotifications?.message);

  const [notification, setNotification] = useState(null);
  const [isOpen, setIsOpen] = useState(false);

  const openCloseHandler = () => setIsOpen((prev) => !prev);

  useEffect(() => {
    setNotification(appNotification);
  }, [appNotification]);

  return (
    <div className={classes.mainContainer}>
      {size.width > layoutResponsive && (
        <>
          <Header openCloseHandler={openCloseHandler} />
          <SidePanel isOpen={isOpen} onClose={() => setIsOpen(false)} />
        </>
      )}
      {children}
      {size.width <= layoutResponsive && <FooterPanel />}
      <AppNotification notification={notification} isDrawerOpen={isOpen} />
    </div>
  );
}
